<app-nav></app-nav>
<section class="checkIn">
  <div class="container">
    <div class="col top-gap-md">
      <button class="btn btn-checkIn" (click)="checkLoggedin('checkIn');">In
        <span class="badge badge-light plan-green-text-badge badge-width">{{successCheckInCount}}</span>
        <span class="badge badge-light plan-red-text-badge badge-width">{{failureCheckInCount}}</span>
      </button>
    </div>
    <div class="col">
      <button class="btn btn-checkIn" (click)="showCheckOutConfirmation();">Out</button>
      <span class="badge badge-light plan-green-text-badge badge-width">{{successCheckOutCount}}</span>
      <span class="badge badge-light plan-red-text-badge badge-width">{{failureCheckOutCount}}</span>
    </div>
    <div class="col">
      <button class="btn btn-checkIn" routerLink="/planLeave">Plan Leave <span class="badge badge-light plan-output-badge badge-width">{{leaveCountNotifications}}</span></button>
    </div>
    <div class="col" *ngIf="supervisorCheck">
        <button class="btn btn-checkIn" routerLink="/team">Team 
          <span class="plan-i-badge">I</span><span class="badge badge-light plan-input-badge badge-width">{{teamSuccessCheckInCount}}</span>
          <span class="plan-o-badge">O</span><span class="badge badge-light plan-output-badge badge-width">{{teamSuccessCheckOutCount}}</span>
          <span class="plan-l-badge">L</span><span class="badge badge-light plan-leave-badge badge-width">{{teamSuccessLeaveCount}}</span>
        </button>
      </div> 
  </div>
  <agm-map [latitude]="lat" [longitude]="lng">
    <agm-marker [latitude]="lat" [longitude]="lng">
    </agm-marker>
  </agm-map>

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
        <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
</div>
  <div class="modal fade" id="checkOutConfirmModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-group text-center">
            <p>You will be checked out for the current day and this action cannot be reverted. Are you sure you want to check out ?</p>
          </div>
        </div>
        <div class="modal-footer text-center">
          <div class="container">
            <div class="col-md-12 text-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary ml-2" (click)="confirmCheckOut()" style="background-color: #005aa9">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="checkInModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="form-group text-center">
              <span [innerHtml]="error || successMessageCheckOut || successMessageCheckIn || locationErrorMessage" class=""></span>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer text-center">
          <div class="container">
            <div class="col-md-12 text-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal" routerLink="/home">Ok</button>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>